import NavLink from './NavLink';
import ScrollTop from './ScrollTop';

const index = {
  NavLink,
  ScrollTop
};

export default index;
